
<div class="container-fluid">
  <div class="row">
    <div class="col-xl-7" [ngStyle]="{'background-image': 'url(assets/images/login/undraw_My_password_re_ydq7.png)',
                                     'background-size': '900px',
                                     
                                     'background-position': 'center center',
                                     'display': 'block'}">
      <img class="bg-img-cover bg-center d-none" src="https://thereceptionist.com/your-complete-guide-visitor-management/" alt="looginpage">
    </div>
    <div class="col-xl-5 p-0">
      <div class="login-card">
        <div>
          <div>
            <a class="logo text-left" href="#"style="justify-content: center;"> 
              <img class="img-fluid for-light" src="assets/images/logo/logo-res.png" style="height:70px; " alt="looginpage" >
              
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage">
              <h2 style="text-align:center">Visitor Management System</h2>
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="form">
              <h4>Create Your Password</h4>
              <div class="form-group">
                <label class="col-form-label"> Enter New Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="newPassword" required=""
                  placeholder="*********">
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
                <div *ngIf="form.controls.newPassword.touched && form.controls.newPassword.errors?.required"
                  class="text text-danger mt-1" style="padding-bottom:15px ;">
                  Password is required
                </div>
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div class="form-group">
                <label class="col-form-label"> Confirm Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="confirmPassword" required=""
                  placeholder="*********">
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
                <div *ngIf="form.controls.confirmPassword.touched && form.controls.confirmPassword.errors?.required"
                  class="text text-danger mt-1" style="padding-bottom:15px ;">
                  Password is required
                </div>
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox">
                  <label class="text-muted" for="checkbox1">Remember password</label>
                </div>
                <button class="btn btn-primary btn-block"  (click)="restPassword()" type="submit">Done</button>
              </div>
              <p class="mt-4 mb-0">Change of mind?<a class="ml-2" routerLink="/login">Sign in</a></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>